import { render, staticRenderFns } from "./SubSidebarMenu.vue?vue&type=template&id=054a0d12&scoped=true"
import script from "./SubSidebarMenu.vue?vue&type=script&lang=js"
export * from "./SubSidebarMenu.vue?vue&type=script&lang=js"
import style0 from "./SubSidebarMenu.vue?vue&type=style&index=0&id=054a0d12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054a0d12",
  null
  
)

export default component.exports